import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTheme } from '../../theme-context';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { CHAT_ACTIONS } from '../../utils/constants/chat-actions';
import { tryToFetchHistoryChats } from '../../store/brokers/partners/history-chats/historyChatsSlice';
import Modal from '../../shared/modal';

interface INewChatModal {
    openModal: boolean;
    handleCloseModal: () => void;
    onClickOpenChat: (id?: string, action?: any) => void;
}

const NewChatModal = ({
    openModal,
    handleCloseModal,
    onClickOpenChat
}: INewChatModal) => {
    const dispatch = useAppDispatch();
    const { theme } = useTheme();
    const [historyChats, setHistoryChats] = useState<any[]>([]);
    const [visibleCount, setVisibleCount] = useState<number>(10);
    const chats = useAppSelector((state) => state?.history?.historyChats);

    useEffect(() => {
        if (chats) {
            const reversedChats = [...chats || []].reverse();
            setHistoryChats(reversedChats);
            setVisibleCount(10);
        }
    }, [chats]);

    const getChatsData = async () => {
        try {
            await dispatch(tryToFetchHistoryChats()).unwrap();
        } catch (err) {
            console.error(err, 'error');
        }
    };

    useEffect(() => {
        getChatsData();
    }, []);

    const onCloseModal = () => {
        handleCloseModal();
    };

    return (
        <Modal
            open={openModal}
            title='Search chats...'
            headerStyle='border-b-1 py-3 mb-4'
            onClose={onCloseModal}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'>
            <div className='p-2 min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px]'>
                <div
                    onClick={() => onClickOpenChat()}
                    className='flex flex-row items-center cursor-pointer hover:opacity-80 px-2'>
                    <img
                        src={theme === 'dark'
                            ? '/assets/navigation-icons/sidebar/new-question-white.svg'
                            : '/assets/navigation-icons/sidebar/new-question.svg'}
                        className='object-contain w-[23px] mr-3'
                    />
                    <p className='dark:text-primary-dark'>New Chat</p>
                </div>
                <div className='my-4 px-1'>
                    <p className='text-primary-light dark:text-primary-dark mb-2'>Previous Chats</p>
                    {historyChats && historyChats.length > 0 ? (
                        <>
                            {historyChats.slice(0, visibleCount).map((item: any, idx: number) => (
                                <div
                                    onClick={() => onClickOpenChat(item._id)}
                                    key={item._id || idx}
                                    className='px-1 rounded-lg cursor-pointer hover:opacity-80 hover:bg-gray-100 dark:hover:bg-black dark:hover:rounded py-1 my-2 flex flex-row items-center'>
                                    <p className='dark:text-primary-dark'>{item?.name}</p>
                                    <p className='text-primary-light ml-4 text-sm'>{moment(item?.createdAt).fromNow()}</p>
                                </div>
                            ))}
                            {visibleCount < historyChats.length && (
                                <div
                                    onClick={() => setVisibleCount((prev) => prev + 10)}
                                    className='flex flex-row justify-center my-2 py-2 cursor-pointer hover:opacity-80'>
                                    <p className='underline dark:text-primary-dark'>Show More</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <p className='px-1 dark:text-primary-dark'>No History</p>
                    )}
                </div>

                <div className='px-1'>
                    <p className='text-primary-light dark:text-primary-dark mb-2'>Actions</p>
                    {CHAT_ACTIONS.map((item: any, idx: number) => (
                        <div
                            key={idx}
                            onClick={() => onClickOpenChat(undefined, item)}
                            className='flex flex-row items-center justify-between my-2 cursor-pointer hover:opacity-80 hover:bg-gray-100 dark:hover:bg-black dark:hover:rounded py-1 px-1'>
                            <div className='flex flex-row items-center'>
                                <img
                                    src={theme === 'dark'
                                        ? '/assets/shared/message-icon-white.svg'
                                        : '/assets/shared/message-icon.svg'}
                                    className='object-contain w-[20px] mr-2'
                                />
                                <p className='dark:text-primary-dark'>{item?.name}</p>
                            </div>
                            <div className='rounded-full bg-[#E4E8EF] px-2'>
                                <p className='text-[#414651] text-sm'>Action</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default NewChatModal;